/** The help articles this browser opened last, so the help panel can offer them again. */

export const RECENT_HELP_KEY = "cg.help.recent";
const MAX_RECENT = 5;

/** Slugs, most recent first. Anything unreadable (no storage, bad JSON, wrong shape) is just empty. */
export function readRecentHelp(): string[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(RECENT_HELP_KEY) ?? "[]");
    if (!Array.isArray(parsed)) return [];
    const slugs = parsed.filter((s): s is string => typeof s === "string" && s !== "");
    return [...new Set(slugs)].slice(0, MAX_RECENT);
  } catch {
    return [];
  }
}

/** Puts `slug` first (once), keeps the newest five and returns the new list. */
export function rememberHelpArticle(slug: string): string[] {
  const current = readRecentHelp();
  if (!slug) return current;
  const next = [slug, ...current.filter((s) => s !== slug)].slice(0, MAX_RECENT);
  try {
    localStorage.setItem(RECENT_HELP_KEY, JSON.stringify(next));
  } catch {
    /* private mode: the list just isn't remembered */
  }
  return next;
}
